
import { RouterProvider } from "react-router";
import { router } from "./routes";
import { Toaster } from "./components/ui/sonner";
import { ErrorBoundary } from "./components/ui/ErrorBoundary";
import { useEffect, useState } from "react";
import { useAuth } from "../lib/auth";
import { BusinessTypeModal } from "./components/onboarding/BusinessTypeModal";

export default function App() {
  const { profile } = useAuth();
  const [showBusinessModal, setShowBusinessModal] = useState(false);

  useEffect(() => {
    const hasSkipped = localStorage.getItem("moniflow_skip_onboarding") === "true";
    if (profile && (profile.business_type === null || profile.business_type === undefined) && !hasSkipped) {
      setShowBusinessModal(true);
    }
  }, [profile]);

  const handleCloseModal = () => {
    localStorage.setItem("moniflow_skip_onboarding", "true");
    setShowBusinessModal(false);
  };

  return (
    <>
      <ErrorBoundary>
        <RouterProvider router={router} />
      </ErrorBoundary>
      <BusinessTypeModal open={showBusinessModal} onClose={handleCloseModal} />
      <Toaster
        position="top-center"
        expand={false}
        richColors
        closeButton
        className="md:bottom-4 md:right-4"
      />
    </>
  );
}
